import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';

import CardBox from 'components/theme/CardBox';
import Table from 'components/custom/Table/AsyncTable';
import FilterForm from 'components/custom/FilterForm';
import { TextField } from 'components/custom/FormElements';
import NewEntityBtn from 'components/custom/NewEntityBtn';
import SettingsActions from 'store/reducers/Settings';
import PurchaseLicenseService from 'services/PurchaseLicense';
import IntlMessages from 'utils/IntlMessages';
import SearchParams from 'utils/SearchParams';
import Util from 'utils/Util';
import PurchaseLicenseEditForm from '../../../../../../components/Admin/University/PurchaseLicenseEditForm';

class PurchasedLicenses extends React.Component {
  state = {
    data: [],
    editModal: false,
  };

  getData = ( params ) => {
    const { toggleLoading, entityId } = this.props;
    toggleLoading( true );

    this.params = _.cloneDeep( params );
    const formattedParams = SearchParams.getSearchParams( this.search, params );
    PurchaseLicenseService.getPurchaseLicenses( entityId, formattedParams )
      .then( ( response ) => {
        toggleLoading( false );

        if ( response.ok ) {
          this.setState( {
            data: response.data.data || [],
            pages: Math.ceil( response.data.total / params.limit ),
            total: response.data.total,
          } );
        }
      } );
  };

  submitForm = ( data ) => {
    this.search = data;
    this.getData( this.params );
  };

  toggleEditModal = ( cb ) => {
    this.setState( previousState => ( { editModal: !previousState.editModal } ), cb );
  };

  render() {
    const { editModal, ...rest } = this.state;
    const { entityId } = this.props;

    return (
      <div>
        <CardBox cardStyle="p-0">
          <FilterForm
            newBtn={(
              <NewEntityBtn
                label="newPurchaseLicense"
                onClick={this.toggleEditModal}
              />
            )}
            onSubmit={this.submitForm}
            onClear={() => {
              this.search = {};
              this.getData( this.params );
            }}
          >
            <div className="col-lg-3">
              <TextField
                field="invoice"
                label="invoice"
              />
            </div>
          </FilterForm>

          <Table
            onFetchData={this.getData}
            {...rest}
            columns={[
              { Header: <IntlMessages id="invoice" />, accessor: 'invoice' },
              { Header: <IntlMessages id="email" />, accessor: 'email' },
              { Header: <IntlMessages id="buyer" />, accessor: 'buyer' },
              {
                Header: <IntlMessages id="quantity" />,
                accessor: 'quantity',
                Cell: ( { value } ) => Util.formatNumber( value ),
              },
              {
                Header: <IntlMessages id="startDate" />,
                accessor: 'startDate',
                Cell: props => ( props.value ? moment( Number( props.value ) ).format( 'DD/MM/YYYY' ) : '' ),
              },
            ]}
          />
        </CardBox>

        <PurchaseLicenseEditForm
          open={editModal}
          onClose={() => this.toggleEditModal()}
          onConfirm={() => {
            this.toggleEditModal();
            this.getData( this.params );
          }}
          entityId={entityId}
        />
      </div>
    );
  }
}

const mapDispatchToProps = {
  toggleAlert: SettingsActions.toggleAlert,
  toggleLoading: SettingsActions.toggleLoading,
};

export default connect(
  null,
  mapDispatchToProps,
)( PurchasedLicenses );
